import { useRef, useState } from 'react';
import { Col, Container, Image, Row } from 'react-bootstrap';
import { Formik, Form, Field } from 'formik';
import { Input } from '../../../Litho/Components/Form/Form';
import Buttons from '../../../Litho/Components/Button/Buttons';
import colors from '../../../constants/colors';
import TrackingDetails from './TrackingDetails';
import ContainerDetails from './ContainerDetails';

const TrackingForm = () => {
  const form = useRef(null);

  // State to manage API response
  const [trackingData, setTrackingData] = useState(null);
  const [noData, setNoData] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const [searchType, setSearchType] = useState('');

  const sendRequest = async (type, referenceNumber) => {
    const url = `https://admin.mcpl.pk/api/trackings?platform=interlinkOceana&tracking=${encodeURIComponent(
      referenceNumber,
    )}&key=${type}`;

    try {
      const response = await fetch(url, { method: 'GET' });
      const data = await response.json();
      console.log('data', data);
      const results = data?.orders?.data;
      console.log('results', results);
      if (results && results?.length > 0) {
        setTrackingData(results);
        setNoData(false);
      } else {
        setTrackingData(null);
        setNoData(true);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setNoData(true); // Show "No data" on error
    }
  };

  return (
    <Container className='mb-20'>
      <h4 className='font-serif text-tprimary font-semibold m-0'>
        Track Shipment
      </h4>
      <Row className='items-center gap-32 p-6'>
        <Col className='col-12 col-lg-5 col-md-8'>
          <Formik
            initialValues={{
              type: 'default',
              referenceNumber: '',
            }}
            onSubmit={async (values, actions) => {
              actions.setSubmitting(true);
              const { type, referenceNumber } = values;

              // Static platform value

              // Call the API
              setSearchInput(referenceNumber);
              setSearchType(type);
              await sendRequest(type, referenceNumber);

              actions.setSubmitting(false);
            }}
          >
            {({ isSubmitting }) => (
              <Form ref={form}>
                <Field
                  as='select'
                  className='pt-[20px] w-full bg-tsecondary h-[60px] border-b border-solid border-tprimary text-[16px] text-[#8e98a6] appearance-none cursor-pointer'
                  name='type'
                >
                  <option
                    className='text-tprimary hover:text-red-700'
                    value='default'
                    disabled
                    hidden
                  >
                    Track By
                  </option>
                  <option
                    className='text-tprimary px-2 py-1 hover:bg-tprimary hover:text-white'
                    value='containerId'
                  >
                    Container Id
                  </option>
                  <option
                    className='text-tprimary px-2 py-1 hover:bg-tprimary hover:text-white'
                    value='ladingNo'
                  >
                    Bill of Lading
                  </option>
                  <option
                    className='text-tprimary px-2 py-1 hover:bg-tprimary hover:text-white'
                    value='bookingNo'
                  >
                    Booking Number
                  </option>
                </Field>

                <Input
                  showErrorMsg={false}
                  type='text'
                  name='referenceNumber'
                  labelClass='mb-[25px]'
                  className='pt-[20px] pr-[36px] pb-[20px] w-full bg-transparent border-b border-solid border-tprimary text-[16px]'
                  placeholder='Reference Number'
                />

                <Buttons
                  type='submit'
                  className={`tracking-[0.5px] btn-flat rounded-full mx-auto font-medium uppercase${
                    isSubmitting ? ' loading' : ''
                  }`}
                  themeColor={colors.tprimary}
                  size='md'
                  color='#fff'
                  title='Track'
                />
              </Form>
            )}
          </Formik>
        </Col>
        <Col className='d-none d-md-block col-lg-3 col-md-8 md:mb-[50px]'>
          <Image
            src='/assets/img/track-shipment/track.png'
            alt='gold-contact'
          />
        </Col>
      </Row>
      {noData && (
        <div className='result-container mb-40'>
          <h5 className='text-tprimary'>No Data found. Please try again.</h5>
        </div>
      )}
      {trackingData && (
        <div className='result-container'>
          <h5 className='font-serif text-tprimary font-semibold m-0 mb-4'>
            Results:
          </h5>

          <TrackingDetails data={trackingData} type={searchType} />
          <ContainerDetails data={trackingData} type={searchType} />
          <ul className='list-disc p-6'>
            <li className='text-tprimary'>
              Red-highlighted values indicate estimated information.
            </li>
            <li>
              Black-highlighted values represent verified and actual data.
            </li>
            <li>
              Interlink Oceana reserves the right to update or modify the
              displayed information at any time without prior notice.
            </li>
            <li>
              If you have any questions or require further assistance, please
              feel free to contact us.
            </li>
          </ul>
        </div>
      )}
      {/* <Row className=' justify-center'>
        <Col className='col-12 col-lg-6 offset-lg-1 col-md-8'>
          <h4 className='font-serif text-tprimary font-semibold m-0'>
            Track Shipment
          </h4>

          {trackingData?.length > 0 ? (
            // Show the tracking data
            <Row className='tracking-data'>
              <Col>
                {trackingData.map((data, index) => (
                  <div>
                    <h6 className='font-semibold mb-2 mt-4'>
                      Details for '{searchInput}'
                    </h6>

                    <Table key={index} bordered className='tracking-table'>
                      <tbody>
                        <tr>
                          <td className='w-50'>
                            <strong>Container Id</strong>
                          </td>
                          <td className='w-50'>
                            {data?.attributes?.containerId || 'N/A'}
                          </td>
                        </tr>
                        <tr>
                          <td className='w-50'>
                            <strong>Bill of Lading Number</strong>
                          </td>
                          <td className='w-50'>
                            {data?.attributes?.ladingNo || 'N/A'}
                          </td>
                        </tr>
                        <tr>
                          <td className='w-50'>
                            <strong>Booking Number</strong>
                          </td>
                          <td className='w-50'>
                            {data?.attributes?.bookingNo || 'N/A'}
                          </td>
                        </tr>
                        <tr>
                          <td className='w-50'>
                            <strong>Shipping Line</strong>
                          </td>
                          <td className='w-50'>
                            {data?.attributes?.shippingLine || 'N/A'}
                          </td>
                        </tr>
                        <tr>
                          <td className='w-50'>
                            <strong>Size / Type</strong>
                          </td>
                          <td className='w-50'>
                            {data?.attributes?.size || 'N/A'}
                          </td>
                        </tr>
                        <tr>
                          <td className='w-50'>
                            <strong>CFS / CV / MTV</strong>
                          </td>
                          <td className='w-50'>
                            {data?.attributes?.cfs || 'N/A'}
                          </td>
                        </tr>
                        <tr>
                          <td className='w-50'>
                            <strong>Seal Number</strong>
                          </td>
                          <td className='w-50'>
                            {data?.attributes?.sealNo || 'N/A'}
                          </td>
                        </tr>
                        <tr>
                          <td className='w-50'>
                            <strong>Category</strong>
                          </td>
                          <td className='w-50'>
                            {data?.attributes?.category || 'N/A'}
                          </td>
                        </tr>
                        <tr>
                          <td className='w-50'>
                            <strong>Gross Weight</strong>
                          </td>
                          <td className='w-50'>
                            {data?.attributes?.weight || 'N/A'}
                          </td>
                        </tr>
                        <tr>
                          <td className='w-50'>
                            <strong>Vessel / Voyage</strong>
                          </td>
                          <td className='w-50'>
                            {data?.attributes?.vessel || 'N/A'}
                          </td>
                        </tr>
                        <tr>
                          <td className='w-50'>
                            <strong>Origin</strong>
                          </td>
                          <td className='w-50'>
                            {data?.attributes?.origin || 'N/A'}
                          </td>
                        </tr>
                        <tr>
                          <td className='w-50'>
                            <strong>Destination</strong>
                          </td>
                          <td className='w-50'>
                            {data?.attributes?.destination || 'N/A'}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                ))}

                <Buttons
                  className='tracking-[0.5px] btn-flat rounded-full mx-auto font-medium uppercase m-4'
                  themeColor={colors.tprimary}
                  size='md'
                  color='#fff'
                  title='Track New Shipment'
                  onClick={() => {
                    setNoData(false);
                    setTrackingData(null); // Reset the state to show the form
                  }}
                />
              </Col>
            </Row>
          ) : noData ? (
            // Show "No data" message and reset button
            <Row className='no-data'>
              <Col className=''>
                <h5 className=' font-semibold mt-6'>No Data Found</h5>
                <Buttons
                  className='tracking-[0.5px] btn-flat rounded-full mx-auto font-medium uppercase m-4'
                  themeColor={colors.tprimary}
                  size='md'
                  color='#fff'
                  title='Track Shipment'
                  onClick={() => {
                    setNoData(false);
                    setTrackingData(null); // Reset the state to show the form
                  }}
                />
              </Col>
            </Row>
          ) : (
            // Show the form
            <Row className='justify-center'>
              <Col className='col-12 col-lg-5 col-md-8 md:mb-[50px]'>
                <Image
                  src='/assets/img/track-shipment/track.png'
                  alt='gold-contact'
                />
              </Col>
              <Col>
                <Formik
                  initialValues={{
                    type: 'default',
                    referenceNumber: '',
                  }}
                  onSubmit={async (values, actions) => {
                    actions.setSubmitting(true);
                    const { type, referenceNumber } = values;

                    // Static platform value
                    const platform = 'interlinkOceana';

                    // Call the API
                    setSearchInput(referenceNumber);
                    await sendRequest(platform, type, referenceNumber);

                    actions.setSubmitting(false);
                  }}
                >
                  {({ isSubmitting }) => (
                    <Form ref={form}>
                      <Field
                        as='select'
                        className='pt-[20px] w-full bg-tsecondary h-[60px] border-b border-solid border-tprimary text-[16px] text-[#8e98a6] appearance-none cursor-pointer'
                        name='type'
                      >
                        <option
                          className='text-tprimary hover:text-red-700'
                          value='default'
                          disabled
                          hidden
                        >
                          Track By
                        </option>
                        <option
                          className='text-tprimary px-2 py-1 hover:bg-tprimary hover:text-white'
                          value='containerId'
                        >
                          Container Id
                        </option>
                        <option
                          className='text-tprimary px-2 py-1 hover:bg-tprimary hover:text-white'
                          value='ladingNo'
                        >
                          Bill of Lading
                        </option>
                        <option
                          className='text-tprimary px-2 py-1 hover:bg-tprimary hover:text-white'
                          value='bookingNo'
                        >
                          Booking Number
                        </option>
                      </Field>

                      <Input
                        showErrorMsg={false}
                        type='text'
                        name='referenceNumber'
                        labelClass='mb-[25px]'
                        className='pt-[20px] pr-[36px] pb-[20px] w-full bg-transparent border-b border-solid border-tprimary text-[16px]'
                        placeholder='Reference Number'
                      />

                      <Buttons
                        type='submit'
                        className={`tracking-[0.5px] btn-flat rounded-full mx-auto font-medium uppercase${
                          isSubmitting ? ' loading' : ''
                        }`}
                        themeColor={colors.tprimary}
                        size='md'
                        color='#fff'
                        title='Track'
                      />
                    </Form>
                  )}
                </Formik>
              </Col>
            </Row>
          )}
        </Col>
      </Row> */}
    </Container>
  );
};

export default TrackingForm;
